import React from 'react'
import { withRouter } from "react-router-dom";
import { Validators, FormOp } from '../../../components/form/FormOps.tsx';
import Http from '../../../Http';
import FormComponent from '../../../components/form/FormOps';

class Od extends FormComponent {

  static defaultProps = {
    onSave: () => { }
  }

  // state = {
  //   odsForm: FormOp.Group([
  //     FormOp.Field('select', 'id_origen', 'Origen', '', [Validators.required], 6, [{ value: 'a', label: 'b' }, { value: 'c', label: 'd' }]),
  //     FormOp.Field('select', 'id_destino', 'Destino', '', [Validators.required], 6),
  //   ],
  //     ['Guardar'], 'Orígenes y destinos')
  // }

  componentDidMount() {
    // this.formData();
    // if (this.props.match.params.id)
    //   this.cargarForm(this.props.match.params.id)

    this.formConfig(
      { defaultUrl: 'od/one', saveUrl: 'od/save', backUrl: '/Catalogo/OrigenesDestinos' },
      FormOp.Group([
        FormOp.Field('select', 'id_origen', 'Origen', '', [Validators.required], 6, [{ value: 'a', label: 'b' }, { value: 'c', label: 'd' }]),
        FormOp.Field('select', 'id_destino', 'Destino', '', [Validators.required], 6),
      ],
        ['Guardar'], 'Orígenes y destinos'), this.formData)

    if (this.props.match.params.id)
      this.loadFormPreds(this.props.match.params.id)
  }

  // cargarForm = async (id) => {
  //   let Res = await Http.get(`od/${id}`);
  //   console.log(Res.data);

  //   if (!Res.error)
  //     this.setState({ formDefault: Res.data })
  // }

  formData = async (form) => {
    var Res = await Http.get('lugar/od-form');
    console.log(Res.data);
    if (!Res.error) {
      var opsOrigenes = FormOp.ModOptions(form, 'id_origen', Res.data.origenes, 'id', 'od_lugar_nombre');
      // this.setState({ odsForm: opsOrigenes });
      var opsDestinos = FormOp.ModOptions(form, 'id_destino', Res.data.destinos, 'id', 'od_lugar_nombre');
      // this.setState({ odsForm: opsDestinos });
      return Object.assign(opsOrigenes, opsDestinos);
    }

  }

  // formData = async () => {
  //   var Res = await Http.get('lugares/od-form');
  //   // console.log(Res.data);
  //   if (!Res.error) {
  //     var opsOrigenes = FormOp.ModOptions(this.state.odsForm, 'id_origen', Res.data.origenes, 'id', 'od_lugar_nombre');
  //     this.setState({ odsForm: opsOrigenes });
  //     var opsDestinos = FormOp.ModOptions(this.state.odsForm, 'id_destino', Res.data.destinos, 'id', 'od_lugar_nombre');
  //     this.setState({ odsForm: opsDestinos });

  //   }
  // }

  // submit = async (i, vals, load) => {
  //   // console.log(vals);
  //   vals.id = this.props.match.params.id;
  //   var Res = await Http.post('od/save', vals);
  //   if (!Res.error) {
  //     load('Guardado', true);
  //     this.props.history.push(`/Catalogos/OrigenesDestinos`)
  //     this.props.onSave();
  //   } else
  //     load('Error al guardar', false);

  // }

  render() {
    // const { odsForm } = this.state;
    // const { params } = this.props.match;
    return (
      // <div className="form-box">
      //   <Form form={odsForm} onSubmit={this.submit} default={(!params.id) ? null : this.state.formDefault} />
      // </div>
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Od)
